module.exports = __webpack_public_path__ + "static/media/iocn_weixianxingwei.8ee1e311.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_inspection/iocn_weixianxingwei.png
// module id = 543
// module chunks = 0